import { render, staticRenderFns } from "./ArchivedCampaigns.vue?vue&type=template&id=b5f774ec&"
import script from "./ArchivedCampaigns.vue?vue&type=script&lang=js&"
export * from "./ArchivedCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports